import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getDelayCategories = async (
  DelayAreaAssetId?: number | null,
  IncludeAncestor?: boolean,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  if (DelayAreaAssetId)
    parameters.push({ name: "DelayAreaAssetId", value: DelayAreaAssetId });
  if (IncludeAncestor)
    parameters.push({ name: "IncludeAncestor", value: IncludeAncestor });

  return await apiService.callV2("[DEL].[GetDelayCategories]", parameters);
};
